import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';

const Index = lazy(() => import('components/DASHBOARD/index'));
const Unauthorized = lazy(() => import('components/DASHBOARD/unauthorized'))
const NotFound = lazy(() => import('components/DASHBOARD/notfound'))

const Dashboard = () => {
  let { path } = useRouteMatch();
  
  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>
        <Route exact path={`${path}/`} component={Index} />
        <Route exact path={`${path}/unauthorized`} component={Unauthorized} />
        <Route exact path={`${path}/notfound`} component={NotFound} />

        <Route path='*'>
          <Redirect to={`${path}/notfound`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Dashboard;
